const items = ["Something Big", "06 / 2026", "Zavico", "Stay Curious", "Signal Locked", "Coming Soon"];

export const Marquee = () => (
  <div data-testid="marquee-ribbon" className="py-8 border-y border-white/10 bg-[#07070b] overflow-hidden whitespace-nowrap select-none">
    <div className="marquee-track inline-flex items-center gap-12">
      {[...items, ...items, ...items, ...items].map((t, i) => (
        <span key={i} className="inline-flex items-center gap-12">
          <span className={`font-display uppercase tracking-[0.3em] text-sm ${i % 2 ? "text-[#8e8ea0]" : "text-[#f8f9fa]"}`}>{t}</span>
          <span className="text-[#00f0ff] text-xs">◆</span>
        </span>
      ))}
    </div>
  </div>
);

export default Marquee;
